<p-menubar [model]="items" styleClass="bg-white">
  <ng-template pTemplate="start">
    <ng-container *ngTemplateOutlet="startTemplate"></ng-container>
  </ng-template>

  <ng-template #item let-item let-root="root">
    <a
      pRipple
      class="p-menubar-item-link"
      [routerLink]="item.items?.length ? null : item.routerLink"
      [queryParams]="item.items?.length ? null : item.queryParams"
      routerLinkActive="p-menubar-item-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      [attr.tabindex]="item.disabled ? null : '-1'"
    >
      <shared-ui-icons-icon *ngIf="item.icon" [iconName]="item.icon" [iconClass]="item.iconClass ?? ''" class="p-menubar-item-icon"></shared-ui-icons-icon>
      <span class="p-menubar-item-label">{{ item.label }}</span>
      <shared-ui-icons-icon *ngIf="item.items" [iconName]="iconType.ArrowDown" class="p-menubar-submenu-icon"></shared-ui-icons-icon>
    </a>
  </ng-template>

  <ng-template pTemplate="end">
    <ng-container *ngTemplateOutlet="endTemplate"></ng-container>
  </ng-template>
</p-menubar>
